export const generalConsultExaminationConstants = {
  heading: 'Examen Físico',
  helpLeft: 'CP = Con evidencia de patología, marcar y describir',
  helpRight: 'SP = Sin evidencia de patología, marcar y describir',
  showDetail: 'Describir detalles',
  detailDescription: 'Selecciona el antecente que deseas describir y luego ingresa la información en el campo de texto',
  disclaimer: 'Recuerda que si ingresaste información adicional por grupo lo vas a poder visualizar al momento de dar click en el botón. Adicionalmente, la información detallada por grupo se va a visualizar en la generación de la história médica.'
};
